export default "__VITE_ASSET__ba1ab516__"